import { Component, DestroyRef, OnInit, inject, input, output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { DeliveryDestinationNote } from 'customers';

// Note riportate in bolla del destino: restano in App, non vanno al gestionale
@Component({
  selector: 'ord-new-customer-delivery-notes',
  imports: [MatFormFieldModule, MatInputModule, MatSlideToggleModule, ReactiveFormsModule],
  templateUrl: './new-customer-delivery-notes.html',
  styleUrl: './new-customer-delivery-notes.scss',
})
export class NewCustomerDeliveryNotes implements OnInit {
  private readonly formBuilder = inject(FormBuilder);
  private readonly destroyRef = inject(DestroyRef);

  readonly nota = input.required<DeliveryDestinationNote>();
  readonly notaChange = output<DeliveryDestinationNote>();

  readonly form = this.formBuilder.nonNullable.group({
    giorni: '',
    orari: '',
    contatto: '',
    notaLibera: '',
    inBolla: false,
    sponda: false,
  });

  ngOnInit(): void {
    const nota = this.nota();
    this.form.setValue({
      giorni: nota.giorni ?? '',
      orari: nota.orari ?? '',
      contatto: nota.contatto ?? '',
      notaLibera: nota.notaLibera ?? '',
      inBolla: nota.inBolla,
      sponda: nota.sponda ?? false,
    }, { emitEvent: false });

    this.form.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      const value = this.form.getRawValue();
      this.notaChange.emit({
        inBolla: value.inBolla,
        notaLibera: value.notaLibera || null,
        orari: value.orari || null,
        contatto: value.contatto || null,
        giorni: value.giorni || null,
        sponda: value.sponda,
      });
    });
  }
}
